export const TRI_CONTRACT = process.env.REACT_APP_TRI_CONTRACT as string;
export const POLYGON_USDT = '0xc2132D05D31c914a87C6611C10748AEb04B58e8F';
export const POLYGON_EDOGE = '0x0AcD96e7b895D534D2216c6Fb5B98fD91Da70C3f';
export const POLYGON_SHUFFLE =
  process.env.NODE_ENV === 'development'
    ? '0x319Cc2379c8610F43c687d9B6E9CC5133519A783'
    : '0xbbe2b016271c22D3DE3f961480AF2941a0C4d067';
export const POLYGON_TRI =
  process.env.NODE_ENV === 'development'
    ? '0x319Cc2379c8610F43c687d9B6E9CC5133519A783'
    : '0x75c2e1e059B885181376dC9107cf8BA30710B791';

export const FACTORY_POOL_CONTRACT = process.env.REACT_APP_FACTORY_CONTRACT!;
// process.env.NODE_ENV === 'production'
//   ? process.env.REACT_APP_FACTORY_CONTRACT
//   : '0x7E4e33f9DB80A03CaAD2aF78e46a502DC0C616f7' // '0x271d8AaaD5D08277803Af404978895924B5E7489';

export const POLYGON_PRIVATE_TOKEN1 =
  process.env.NODE_ENV === 'production'
    ? '0x7583f44B395Ccd3b98391D6200a506968f5BEe75'
    : '0xb2D6Ddfa95aADDfDe938FF8036f2AF368d03367B';

export const POLYGON_PRIVATE_TOKEN2 = '0x27d238C2ac6420F1A506DbE8b13d1F15A1c85460' as const;
export const POLYGON_PRIVATE_TEST3 = '0x0AcD96e7b895D534D2216c6Fb5B98fD91Da70C3f' as const;

export const POLYGON_PRIVATE_TOKEN1_CONTRACT_ADDRESS =
  process.env.NODE_ENV === 'production'
    ? '0x5C45fc0322614ABC59D44626c36Cc4Bb030DcaFd'
    : '0xACC601F1496428972dbF8A0aD06097bE9Cc22647';

export const POLYGON_PRIVATE_TOKEN2_CONTRACT_ADDRESS = '0xe8756FCA96Ce40EC997982b02E52ecDd6Bb1bCDf';
